/**
 * @file: 物理移动
 * @author: xiaolong.huang@dmall.com
 */

import { cubeModify } from '../../update/cubeModify';

function physics(taskQueue: PhysicsMoveTask[]): void {
    taskQueue.forEach((physicsTask: PhysicsMoveTask): void => {
        cubeModify(physicsTask.to.moveTarget, {
            posX: physicsTask.to.position.left,
            posY: physicsTask.to.position.bottom
        });
    });
}

export {
    physics
};
